import { ApiMethods } from "../utils/constants"
import { ApiRequest } from "./api-request"

export async function forgotPassword(data) {
  try {
    const response = await ApiRequest({
      url: "user/forgotPassword",
      method: ApiMethods.POST,
      data,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}

export async function verifyOtp(data) {
  try {
    const response = await ApiRequest({
      url: "user/verifyOtp",
      method: ApiMethods.GET,
      params: data,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}

export async function changePassword(data) {
  try {
    const response = await ApiRequest({
      url: "user/changePassword",
      method: ApiMethods.POST,
      data,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}

export async function getLogin(data) {
  try {
    const response = await ApiRequest({
      url: "/login",
      method: ApiMethods.POST,
      data,
    })
    const result = response.data
    return result
  } catch (error) {
    return error
  }
}

export async function getData() {
  try {
    const accessToken = localStorage.getItem("accessToken")
    // if (accessToken) {
    //     config.headers["Authorization"] = `Bearer ${accessToken}`;
    // }

    // axios.get('http://10.30.2.126:5000/protected', {
    //     withCredentials: true,
    //     headers: {
    //         "Content-Type": "application/json;charset=utf-8",
    //         "Cache-Control": "no-cache",
    //         "Authorization": `Bearer ${accessToken}`
    //     }
    // })
    //     .then(response => {
    //         console.log(response.data);
    //     })
    //     .catch(error => {
    //         console.error('Error fetching data:', error);
    //     });

    const response = await ApiRequest({
      url: "/protected",
      method: ApiMethods.GET,
    })
    console.log("getData response 123", response)
    return response
  } catch (error) {
    console.log("err", error)
    return { error }
  }
}
